{
  const COUNTRIES = [
    { iso: 'AF', name: 'Afganistán', dial: '+93' },
    { iso: 'AX', name: 'Islas Aland', dial: '+358' },
    { iso: 'AL', name: 'Albania', dial: '+355' },
    { iso: 'DZ', name: 'Argelia', dial: '+213' },
    { iso: 'AD', name: 'Andorra', dial: '+376' },
    { iso: 'AO', name: 'Angola', dial: '+244' },
    { iso: 'AI', name: 'Anguila', dial: '+1' },
    { iso: 'AG', name: 'Antigua y Barbuda', dial: '+1' },
    { iso: 'AR', name: 'Argentina', dial: '+54' },
    { iso: 'AM', name: 'Armenia', dial: '+374' },
    { iso: 'AW', name: 'Aruba', dial: '+297' },
    { iso: 'AC', name: 'Isla de la Ascensión', dial: '+247' },
    { iso: 'AU', name: 'Australia', dial: '+61' },
    { iso: 'AT', name: 'Austria', dial: '+43' },
    { iso: 'AZ', name: 'Azerbaiyán', dial: '+994' },
    { iso: 'BS', name: 'Bahamas', dial: '+1' },
    { iso: 'BH', name: 'Baréin', dial: '+973' },
    { iso: 'BD', name: 'Bangladés', dial: '+880' },
    { iso: 'BB', name: 'Barbados', dial: '+1' },
    { iso: 'BY', name: 'Bielorrusia', dial: '+375' },
    { iso: 'BE', name: 'Bélgica', dial: '+32' },
    { iso: 'BZ', name: 'Belice', dial: '+501' },
    { iso: 'BJ', name: 'Benín', dial: '+229' },
    { iso: 'BM', name: 'Bermudas', dial: '+1' },
    { iso: 'BT', name: 'Bután', dial: '+975' },
    { iso: 'BO', name: 'Bolivia', dial: '+591' },
    { iso: 'BA', name: 'Bosnia y Herzegovina', dial: '+387' },
    { iso: 'BW', name: 'Botsuana', dial: '+267' },
    { iso: 'BV', name: 'Isla Bouvet', dial: '+47' },
    { iso: 'BR', name: 'Brasil', dial: '+55' },
    { iso: 'IO', name: 'Territorio Británico del Océano Índico', dial: '+246' },
    { iso: 'BN', name: 'Brunéi', dial: '+673' },
    { iso: 'BG', name: 'Bulgaria', dial: '+359' },
    { iso: 'BF', name: 'Burkina Faso', dial: '+226' },
    { iso: 'BI', name: 'Burundi', dial: '+257' },
    { iso: 'KH', name: 'Camboya', dial: '+855' },
    { iso: 'CA', name: 'Canadá', dial: '+1' },
    { iso: 'CV', name: 'Cabo Verde', dial: '+238' },
    { iso: 'BQ', name: 'Caribe neerlandés', dial: '+599' },
    { iso: 'KY', name: 'Islas Caimán', dial: '+1' },
    { iso: 'CF', name: 'República Centroafricana', dial: '+236' },
    { iso: 'TD', name: 'Chad', dial: '+235' },
    { iso: 'CL', name: 'Chile', dial: '+56' },
    { iso: 'CN', name: 'China', dial: '+86' },
    { iso: 'CX', name: 'Isla de Navidad', dial: '+61' },
    { iso: 'CC', name: 'Islas Cocos', dial: '+891' },
    { iso: 'CO', name: 'Colombia', dial: '+57' },
    { iso: 'KM', name: 'Comoras', dial: '+269' },
    { iso: 'CG', name: 'Congo', dial: '+242' },
    { iso: 'CD', name: 'República Democrática del Congo', dial: '+243' },
    { iso: 'CK', name: 'Islas Cook', dial: '+682' },
    { iso: 'CR', name: 'Costa Rica', dial: '+506' },
    { iso: 'HR', name: 'Croacia', dial: '+385' },
    { iso: 'CU', name: 'Cuba', dial: '+53' },
    { iso: 'CW', name: 'Curazao', dial: '+599' },
    { iso: 'CY', name: 'Chipre', dial: '+357' },
    { iso: 'CZ', name: 'Chequia', dial: '+420' },
    { iso: 'CI', name: 'Côte d’Ivoire', dial: '+225' },
    { iso: 'DK', name: 'Dinamarca', dial: '+45' },
    { iso: 'DJ', name: 'Yibuti', dial: '+253' },
    { iso: 'DM', name: 'Dominica', dial: '+1' },
    { iso: 'DO', name: 'República Dominicana', dial: '+1' },
    { iso: 'EC', name: 'Ecuador', dial: '+593' },
    { iso: 'EG', name: 'Egipto', dial: '+20' },
    { iso: 'SV', name: 'El Salvador', dial: '+503' },
    { iso: 'GQ', name: 'Guinea Ecuatorial', dial: '+240' },
    { iso: 'ER', name: 'Eritrea', dial: '+291' },
    { iso: 'EE', name: 'Estonia', dial: '+372' },
    { iso: 'SZ', name: 'Esuatini', dial: '+268' },
    { iso: 'ET', name: 'Etiopía', dial: '+251' },
    { iso: 'FK', name: 'Islas Malvinas', dial: '+500' },
    { iso: 'FO', name: 'Islas Feroe', dial: '+298' },
    { iso: 'FJ', name: 'Fiyi', dial: '+679' },
    { iso: 'FI', name: 'Finlandia', dial: '+358' },
    { iso: 'FR', name: 'Francia', dial: '+33' },
    { iso: 'GF', name: 'Guayana Francesa', dial: '+594' },
    { iso: 'PF', name: 'Polinesia Francesa', dial: '+689' },
    { iso: 'TF', name: 'Territorios Australes Franceses', dial: '+262' },
    { iso: 'GA', name: 'Gabón', dial: '+241' },
    { iso: 'GM', name: 'Gambia', dial: '+220' },
    { iso: 'GE', name: 'Georgia', dial: '+995' },
    { iso: 'DE', name: 'Alemania', dial: '+49' },
    { iso: 'GH', name: 'Ghana', dial: '+233' },
    { iso: 'GI', name: 'Gibraltar', dial: '+350' },
    { iso: 'GR', name: 'Grecia', dial: '+30' },
    { iso: 'GL', name: 'Groenlandia', dial: '+299' },
    { iso: 'GD', name: 'Granada', dial: '+1' },
    { iso: 'GP', name: 'Guadalupe', dial: '+590' },
    { iso: 'GT', name: 'Guatemala', dial: '+502' },
    { iso: 'GG', name: 'Guernesey', dial: '+44' },
    { iso: 'GN', name: 'Guinea', dial: '+224' },
    { iso: 'GW', name: 'Guinea-Bisáu', dial: '+245' },
    { iso: 'GY', name: 'Guyana', dial: '+592' },
    { iso: 'HT', name: 'Haití', dial: '+509' },
    { iso: 'HM', name: 'Islas Heard y McDonald', dial: '+0' },
    { iso: 'VA', name: 'Ciudad del Vaticano', dial: '+39' },
    { iso: 'HN', name: 'Honduras', dial: '+504' },
    { iso: 'HK', name: 'RAE de Hong Kong (China)', dial: '+852' },
    { iso: 'HU', name: 'Hungría', dial: '+36' },
    { iso: 'IS', name: 'Islandia', dial: '+354' },
    { iso: 'IN', name: 'India', dial: '+91' },
    { iso: 'ID', name: 'Indonesia', dial: '+62' },
    { iso: 'IR', name: 'Irán', dial: '+98' },
    { iso: 'IQ', name: 'Irak', dial: '+964' },
    { iso: 'IE', name: 'Irlanda', dial: '+353' },
    { iso: 'IM', name: 'Isla de Man', dial: '+44' },
    { iso: 'IL', name: 'Israel', dial: '+972' },
    { iso: 'IT', name: 'Italia', dial: '+39' },
    { iso: 'JM', name: 'Jamaica', dial: '+1' },
    { iso: 'JP', name: 'Japón', dial: '+81' },
    { iso: 'JE', name: 'Jersey', dial: '+44' },
    { iso: 'JO', name: 'Jordania', dial: '+962' },
    { iso: 'KZ', name: 'Kazajistán', dial: '+7' },
    { iso: 'KE', name: 'Kenia', dial: '+254' },
    { iso: 'KI', name: 'Kiribati', dial: '+686' },
    { iso: 'KP', name: 'Corea del Norte', dial: '+850' },
    { iso: 'XK', name: 'Kosovo', dial: '+383' },
    { iso: 'KW', name: 'Kuwait', dial: '+965' },
    { iso: 'KG', name: 'Kirguistán', dial: '+996' },
    { iso: 'LA', name: 'Laos', dial: '+856' },
    { iso: 'LV', name: 'Letonia', dial: '+371' },
    { iso: 'LB', name: 'Líbano', dial: '+961' },
    { iso: 'LS', name: 'Lesoto', dial: '+266' },
    { iso: 'LR', name: 'Liberia', dial: '+231' },
    { iso: 'LY', name: 'Libia', dial: '+218' },
    { iso: 'LI', name: 'Liechtenstein', dial: '+423' },
    { iso: 'LT', name: 'Lituania', dial: '+370' },
    { iso: 'LU', name: 'Luxemburgo', dial: '+352' },
    { iso: 'MO', name: 'RAE de Macao (China)', dial: '+853' },
    { iso: 'MG', name: 'Madagascar', dial: '+261' },
    { iso: 'MW', name: 'Malaui', dial: '+265' },
    { iso: 'MY', name: 'Malasia', dial: '+60' },
    { iso: 'MV', name: 'Maldivas', dial: '+960' },
    { iso: 'ML', name: 'Mali', dial: '+223' },
    { iso: 'MT', name: 'Malta', dial: '+356' },
    { iso: 'MQ', name: 'Martinica', dial: '+596' },
    { iso: 'MR', name: 'Mauritania', dial: '+222' },
    { iso: 'MU', name: 'Mauricio', dial: '+230' },
    { iso: 'YT', name: 'Mayotte', dial: '+262' },
    { iso: 'MX', name: 'México', dial: '+52' },
    { iso: 'MD', name: 'Moldavia', dial: '+373' },
    { iso: 'MC', name: 'Mónaco', dial: '+377' },
    { iso: 'MN', name: 'Mongolia', dial: '+976' },
    { iso: 'ME', name: 'Montenegro', dial: '+382' },
    { iso: 'MS', name: 'Montserrat', dial: '+1' },
    { iso: 'MA', name: 'Marruecos', dial: '+212' },
    { iso: 'MZ', name: 'Mozambique', dial: '+258' },
    { iso: 'MM', name: 'Myanmar (Birmania)', dial: '+95' },
    { iso: 'NA', name: 'Namibia', dial: '+264' },
    { iso: 'NR', name: 'Nauru', dial: '+674' },
    { iso: 'NP', name: 'Nepal', dial: '+977' },
    { iso: 'NL', name: 'Países Bajos', dial: '+31' },
    { iso: 'AN', name: 'Antillas Holandesas', dial: '+599' },
    { iso: 'NC', name: 'Nueva Caledonia', dial: '+687' },
    { iso: 'NZ', name: 'Nueva Zelanda', dial: '+64' },
    { iso: 'NI', name: 'Nicaragua', dial: '+505' },
    { iso: 'NE', name: 'Níger', dial: '+227' },
    { iso: 'NG', name: 'Nigeria', dial: '+234' },
    { iso: 'NU', name: 'Niue', dial: '+683' },
    { iso: 'NF', name: 'Isla Norfolk', dial: '+672' },
    { iso: 'MK', name: 'Macedonia del Norte', dial: '+389' },
    { iso: 'NO', name: 'Noruega', dial: '+47' },
    { iso: 'OM', name: 'Omán', dial: '+968' },
    { iso: 'PK', name: 'Pakistán', dial: '+92' },
    { iso: 'PS', name: 'Territorios Palestinos', dial: '+970' },
    { iso: 'PA', name: 'Panamá', dial: '+507' },
    { iso: 'PG', name: 'Papúa Nueva Guinea', dial: '+675' },
    { iso: 'PY', name: 'Paraguay', dial: '+595' },
    { iso: 'PE', name: 'Perú', dial: '+51' },
    { iso: 'PH', name: 'Filipinas', dial: '+63' },
    { iso: 'PN', name: 'Islas Pitcairn', dial: '+64' },
    { iso: 'PL', name: 'Polonia', dial: '+48' },
    { iso: 'PT', name: 'Portugal', dial: '+351' },
    { iso: 'QA', name: 'Catar', dial: '+974' },
    { iso: 'CM', name: 'Camerún', dial: '+237' },
    { iso: 'RE', name: 'Reunión', dial: '+262' },
    { iso: 'RO', name: 'Rumanía', dial: '+40' },
    { iso: 'RU', name: 'Rusia', dial: '+7' },
    { iso: 'RW', name: 'Ruanda', dial: '+250' },
    { iso: 'BL', name: 'San Bartolomé', dial: '+590' },
    { iso: 'SH', name: 'Santa Elena', dial: '+290' },
    { iso: 'KN', name: 'San Cristóbal y Nieves', dial: '+1' },
    { iso: 'LC', name: 'Santa Lucía', dial: '+1' },
    { iso: 'MF', name: 'San Martín', dial: '+590' },
    { iso: 'PM', name: 'San Pedro y Miquelón', dial: '+508' },
    { iso: 'WS', name: 'Samoa', dial: '+685' },
    { iso: 'SM', name: 'San Marino', dial: '+378' },
    { iso: 'ST', name: 'Santo Tomé y Príncipe', dial: '+239' },
    { iso: 'SA', name: 'Arabia Saudí', dial: '+966' },
    { iso: 'SN', name: 'Senegal', dial: '+221' },
    { iso: 'RS', name: 'Serbia', dial: '+381' },
    { iso: 'SC', name: 'Seychelles', dial: '+248' },
    { iso: 'SL', name: 'Sierra Leona', dial: '+232' },
    { iso: 'SG', name: 'Singapur', dial: '+65' },
    { iso: 'SX', name: 'Sint Maarten', dial: '+1' },
    { iso: 'SK', name: 'Eslovaquia', dial: '+421' },
    { iso: 'SI', name: 'Eslovenia', dial: '+386' },
    { iso: 'SB', name: 'Islas Salomón', dial: '+677' },
    { iso: 'SO', name: 'Somalia', dial: '+252' },
    { iso: 'ZA', name: 'Sudáfrica', dial: '+27' },
    { iso: 'GS', name: 'Islas Georgia del Sur y Sandwich del Sur', dial: '+500' },
    { iso: 'KR', name: 'Corea del Sur', dial: '+82' },
    { iso: 'SS', name: 'Sudán del Sur', dial: '+211' },
    { iso: 'ES', name: 'España', dial: '+34' },
    { iso: 'LK', name: 'Sri Lanka', dial: '+94' },
    { iso: 'VC', name: 'San Vicente y las Granadinas', dial: '+1' },
    { iso: 'SD', name: 'Sudán', dial: '+249' },
    { iso: 'SR', name: 'Surinam', dial: '+597' },
    { iso: 'SJ', name: 'Svalbard y Jan Mayen', dial: '+47' },
    { iso: 'SE', name: 'Suecia', dial: '+46' },
    { iso: 'CH', name: 'Suiza', dial: '+41' },
    { iso: 'SY', name: 'Siria', dial: '+963' },
    { iso: 'TW', name: 'Taiwán', dial: '+886' },
    { iso: 'TJ', name: 'Tayikistán', dial: '+992' },
    { iso: 'TZ', name: 'Tanzania', dial: '+255' },
    { iso: 'TH', name: 'Tailandia', dial: '+66' },
    { iso: 'TL', name: 'Timor-Leste', dial: '+670' },
    { iso: 'TG', name: 'Togo', dial: '+228' },
    { iso: 'TK', name: 'Tokelau', dial: '+690' },
    { iso: 'TO', name: 'Tonga', dial: '+676' },
    { iso: 'TT', name: 'Trinidad y Tobago', dial: '+1' },
    { iso: 'TA', name: 'Tristán de Acuña', dial: '+2908' },
    { iso: 'TN', name: 'Túnez', dial: '+216' },
    { iso: 'TR', name: 'Turquía', dial: '+90' },
    { iso: 'TM', name: 'Turkmenistán', dial: '+993' },
    { iso: 'TC', name: 'Islas Turcas y Caicos', dial: '+1' },
    { iso: 'TV', name: 'Tuvalu', dial: '+688' },
    { iso: 'UG', name: 'Uganda', dial: '+256' },
    { iso: 'UA', name: 'Ucrania', dial: '+380' },
    { iso: 'AE', name: 'Emiratos Árabes Unidos', dial: '+971' },
    { iso: 'GB', name: 'Reino Unido', dial: '+44' },
    { iso: 'US', name: 'Estados Unidos', dial: '+1' },
    { iso: 'UM', name: 'Islas menores alejadas de EE. UU.', dial: '+1' },
    { iso: 'UY', name: 'Uruguay', dial: '+598' },
    { iso: 'UZ', name: 'Uzbekistán', dial: '+998' },
    { iso: 'VU', name: 'Vanuatu', dial: '+678' },
    { iso: 'VE', name: 'Venezuela', dial: '+58' },
    { iso: 'VN', name: 'Vietnam', dial: '+84' },
    { iso: 'VG', name: 'Islas Vírgenes Británicas', dial: '+1' },
    { iso: 'WF', name: 'Wallis y Futuna', dial: '+681' },
    { iso: 'EH', name: 'Sáhara Occidental', dial: '+212' },
    { iso: 'YE', name: 'Yemen', dial: '+967' },
    { iso: 'ZM', name: 'Zambia', dial: '+260' },
    { iso: 'ZW', name: 'Zimbabue', dial: '+263' }
  ]

  const flagEmoji = (iso) =>
    [...iso.toUpperCase()].map((c) => String.fromCodePoint(127397 + c.charCodeAt(0))).join('')

  const setupPhoneSelector = (form) => {
    const field = form.querySelector('[data-phone-field]')
    if (!field || field.dataset.phoneReady === 'true') return field
    field.dataset.phoneReady = 'true'

    const toggle = field.querySelector('[data-phone-toggle]')
    const list = field.querySelector('[data-phone-list]')
    const flagEl = field.querySelector('[data-phone-flag]')
    const prefixEl = field.querySelector('[data-phone-prefix]')
    const input = field.querySelector('[data-phone-input]')
    if (!toggle || !list || !flagEl || !prefixEl) return field

    const defaultIso = (field.dataset.defaultCountry || 'AR').toUpperCase()
    let selectedIndex = COUNTRIES.findIndex((c) => c.iso === defaultIso)
    if (selectedIndex < 0) selectedIndex = 0

    const items = COUNTRIES.map((country, index) => {
      const li = document.createElement('li')
      li.className = 'gform__phone-list-item'
      li.setAttribute('role', 'option')
      li.dataset.index = String(index)
      li.textContent = `${country.name} ${country.dial}`
      list.appendChild(li)
      return li
    })

    const applySelection = (index) => {
      const country = COUNTRIES[index]
      if (!country) return
      selectedIndex = index
      flagEl.textContent = flagEmoji(country.iso)
      prefixEl.textContent = country.dial
      items.forEach((li, i) => {
        const isSelected = i === index
        li.classList.toggle('is-selected', isSelected)
        li.setAttribute('aria-selected', isSelected ? 'true' : 'false')
      })
    }

    const isOpen = () => toggle.getAttribute('aria-expanded') === 'true'

    const open = () => {
      list.hidden = false
      toggle.setAttribute('aria-expanded', 'true')
      const current = items[selectedIndex]
      if (current) current.scrollIntoView({ block: 'center' })
    }

    const close = () => {
      list.hidden = true
      toggle.setAttribute('aria-expanded', 'false')
    }

    const choose = (index) => {
      applySelection(index)
      close()
      toggle.focus()
    }

    toggle.addEventListener('click', () => {
      if (isOpen()) close()
      else open()
    })

    list.addEventListener('click', (event) => {
      const item = event.target.closest('[data-index]')
      if (!item) return
      choose(Number(item.dataset.index))
    })

    toggle.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault()
        if (!isOpen()) open()
        const step = event.key === 'ArrowDown' ? 1 : -1
        applySelection((selectedIndex + step + COUNTRIES.length) % COUNTRIES.length)
        items[selectedIndex].scrollIntoView({ block: 'nearest' })
      } else if (event.key === 'Enter' || event.key === ' ') {
        if (isOpen()) {
          event.preventDefault()
          choose(selectedIndex)
        }
      } else if (event.key === 'Escape') {
        if (isOpen()) close()
      }
    })

    document.addEventListener('click', (event) => {
      if (isOpen() && !field.contains(event.target)) close()
    })

    applySelection(selectedIndex)

    field._selectedDial = () => COUNTRIES[selectedIndex]?.dial || ''
    if (input) input.dataset.dialReady = 'true'
    return field
  }

  const splitDateForGoogleForms = (form) => {
    const dateInput = form.querySelector('input[type="date"]')
    if (!dateInput || !dateInput.value) return
    const entryName = dateInput.getAttribute('name')
    if (!entryName) return

    const [year, month, day] = dateInput.value.split('-')
    if (!year || !month || !day) return

    dateInput.removeAttribute('name')

    const fields = [
      { name: `${entryName}_year`, value: year },
      { name: `${entryName}_month`, value: String(parseInt(month, 10)) },
      { name: `${entryName}_day`, value: String(parseInt(day, 10)) }
    ]

    fields.forEach(({ name, value }) => {
      const hidden = document.createElement('input')
      hidden.type = 'hidden'
      hidden.name = name
      hidden.value = value
      form.appendChild(hidden)
    })
  }

  const prefixPhoneForGoogleForms = (form, phoneInput, field) => {
    const raw = phoneInput.value.trim()
    if (!raw) return
    const entryName = phoneInput.getAttribute('name')
    if (!entryName) return

    const dial = field?._selectedDial?.() || '+54'

    phoneInput.removeAttribute('name')

    const hidden = document.createElement('input')
    hidden.type = 'hidden'
    hidden.name = entryName
    hidden.value = raw.startsWith(dial) || raw.startsWith('+') ? raw : `${dial} ${raw}`
    form.appendChild(hidden)
  }

  const init = (form) => {
    if (form.dataset.googleFormReady === 'true') return
    form.dataset.googleFormReady = 'true'

    const wrapper = form.closest('.gform__wrapper')
    const iframe = wrapper?.querySelector('[data-google-form-iframe]')
    const success = wrapper?.querySelector('[data-success]')
    const button = form.querySelector('[data-submit-button]')
    const phoneInput = form.querySelector('[data-phone-input]')
    const phoneField = setupPhoneSelector(form)

    if (!iframe || !success || !button) return

    let submitted = false

    form.addEventListener('submit', () => {
      if (phoneInput) prefixPhoneForGoogleForms(form, phoneInput, phoneField)

      splitDateForGoogleForms(form)

      const sendingLabel = button.dataset.sendingLabel
      if (sendingLabel) {
        const label = button.querySelector('span')
        if (label) label.textContent = sendingLabel
      }
      button.dataset.loading = 'true'
      submitted = true
    })

    iframe.addEventListener('load', () => {
      if (!submitted) return
      form.hidden = true
      success.hidden = false
      success.setAttribute('tabindex', '-1')
      success.focus({ preventScroll: false })
      success.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  }

  const initAll = () => {
    document.querySelectorAll('[data-google-form]').forEach(init)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-google-form]').forEach(init)
  })
}
